import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const CalendarIconCleanSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M19.3965 4.625H5.39648C4.29191 4.625 3.39648 5.52043 3.39648 6.625V20.625C3.39648 21.7296 4.29191 22.625 5.39648 22.625H19.3965C20.5011 22.625 21.3965 21.7296 21.3965 20.625V6.625C21.3965 5.52043 20.5011 4.625 19.3965 4.625Z'
      stroke='black'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16.3965 2.625V6.625'
      stroke='black'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8.39648 2.625V6.625'
      stroke='black'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3.39648 10.625H21.3965'
      stroke='black'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const CalendarIconClean = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CalendarIconCleanSvg} {...props} />
);
